import React from "react"
export default props => {
    const repasses = props.repasses
    return (
        <>
            <div className="title-section">{props.title}</div>
            <table className="table is-bordered" style={{ marginTop: 5 }}>
                <thead>
                    <tr>
                        <th>##</th>
                        <th>Valor</th>
                        <th>Pagamento</th>
                        <th style={{ width: 80, textAlign: "center" }}>Extrato</th>
                    </tr>
                </thead>
                <tbody>
                    {repasses.map(repasse => {
                        return (
                            <tr key={repasse.numero.toString()}>
                                <td>{repasse.numero}</td>
                                <td>{repasse.valor}</td>
                                <td>{repasse.date}</td>
                                <td style={{ textAlign: "center" }}>
                                    <a
                                        rel="noopener noreferrer"
                                        href={repasse.link}
                                        target="_blank"
                                        className="button is-primary is-small"
                                    >
                                        Ver Extrato
                                    </a>
                                </td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>
        </>
    )
}
